var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{attrs:{"size":"small","title":"Facture","type":"primary"}},[(_vm.hasReceivedInvoice)?[_c('div',{staticClass:"flex justify-between gap-x-4"},[_c('div',[_c('span',{staticClass:"font-bold"},[_vm._v("No. de la facture: ")]),_vm._v(" "+_vm._s(_vm.getInvoiceNumber)+" ")])])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }